'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _DomEvents = require('../utils/DomEvents');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIForm',

  propTypes: {
    action: _react.PropTypes.string,
    children: _react.PropTypes.node.isRequired,
    onSubmit: _react.PropTypes.func
  },

  handleKeyDown: function handleKeyDown(evt) {
    var _props = this.props,
        onKeyDown = _props.onKeyDown,
        onSubmit = _props.onSubmit;
    var key = evt.key;

    var inputFocused = document.activeElement instanceof HTMLInputElement;
    if (key === 'Enter') {
      if (evt.metaKey || evt.ctrlKey && !inputFocused) {
        (0, _Functions.callIfPossible)(onSubmit, (0, _SyntheticEvent2.default)());
      }
    }
    (0, _Functions.callIfPossible)(onKeyDown, evt);
  },
  render: function render() {
    var _props2 = this.props,
        action = _props2.action,
        className = _props2.className,
        children = _props2.children,
        __onKeyDown = _props2.onKeyDown,
        onSubmit = _props2.onSubmit,
        rest = _objectWithoutProperties(_props2, ['action', 'className', 'children', 'onKeyDown', 'onSubmit']);

    return (
      /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
      _react2.default.createElement(
        'form',
        _extends({}, rest, {
          className: (0, _classNames2.default)('private-form', className),
          action: action,
          onKeyDown: this.handleKeyDown,
          onSubmit: !action && !onSubmit ? _DomEvents.preventDefaultHandler : onSubmit
        }),
        children
      )
      /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */

    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/form/UIForm.js
// module id = 556
// module chunks = 171